import ChatbotQuestion from '@/modules/core/data/types/CDE/ChatbotQuestion';

export const shouldAnimateCurrentQuestion = (updatedQuestion: Partial<ChatbotQuestion>, currentQuestion: Partial<ChatbotQuestion>): boolean => {
  const updatedQuestionOrder = updatedQuestion?.order;
  const currentQuestionOrder = currentQuestion?.order;

  // Don't animate the current question when the question that was updated is null (because it means we're cancelling the animation)
  // Don't animate the current question when the question that was updated is the same question (doesn't make sense)
  if (updatedQuestionOrder === null || updatedQuestionOrder === currentQuestionOrder) {
    return false;
  } else {
    return updatedQuestionOrder < currentQuestionOrder;
  }
};

export default shouldAnimateCurrentQuestion;
